import { Method, getMakeAPI } from '@golden/gdk-base';
const makeAPI = getMakeAPI('v1');
const makePlayerAPI = getMakeAPI('player/v1');
const ACTIVITY_LAYOUT_API_PATH = '/activity/layout';
const ACTIVITY_API = {
    GET_ACTIVITY_LIST: makeAPI(Method.GET, '/activities')(),
    GET_LAYOUT_INFO: makeAPI(Method.GET, ACTIVITY_LAYOUT_API_PATH)(),
    POST_ACTIVITY_LAYOUT: makePlayerAPI(Method.POST, ACTIVITY_LAYOUT_API_PATH)(),
    DELETE_ACTIVITY_LAYOUT: makePlayerAPI(Method.DELETE, ACTIVITY_LAYOUT_API_PATH)(),
    GET_LAYOUT_DEPOSIT_LIST: makePlayerAPI(Method.GET, '/activity/layout/deposits')()
};
const NEW_MEMBER_BONUS_API = {
    GET_NEW_MEMBER_BONUS: makeAPI(Method.GET, '/activity/new-member-bonus')(),
    POST_NEW_MEMBER_BONUS: makePlayerAPI(Method.POST, '/activity/new-member-bonus')(),
    POST_NEW_MEMBER_BONUS_PROCESS: makePlayerAPI(Method.POST, '/activity/new-member-bonus/process')()
};
const RECOMMEND_FRIEND_API = {
    GET_RECOMMEND_FRIEND: makePlayerAPI(Method.GET, '/activity/recommend_friend')(),
    POST_RECOMMEND_FRIEND: makePlayerAPI(Method.POST, '/activity/recommend_friend')(),
    POST_RECOMMEND_FRIEND_PROCESS: makePlayerAPI(Method.POST, '/activity/recommend_friend/process')(),
    GET_RECOMMEND_FRIEND_INFO: makeAPI(Method.GET, '/activity/recommend_friend/info')()
};
const INVITE_FRIEND_API = {
    GET_INVITE_FRIEND: makeAPI(Method.GET, '/activity/invite-friend')(),
    GET_INVITE_FRIEND_RELATIONS: makePlayerAPI(Method.GET, '/activity/invite-friend/relations')(),
    POST_INVITE_FRIEND_CLAIM_REWARDS: makePlayerAPI(Method.POST, '/activity/invite-friend/claim-rewards')(),
    GET_INVITE_FRIEND_BONUS: makePlayerAPI(Method.GET, '/activity/invite-friend/bonus')(),
    POST_INVITE_FRIEND_BIND_FRIEND: makePlayerAPI(Method.POST, '/activity/invite-friend/bind-friend')(),
    GET_INVITE_FRIEND_QR_CODE: makePlayerAPI(Method.GET, '/activity/invite-friend/qr-code')(),
};
const HIGH_CASH_BACK_API = {
    GET_HIGH_CASH_BACK_INFO: makeAPI(Method.GET, '/activity/feedback/info')()
};
const NEW_YEAR_2023_API = {
    GET_NEW_YEAR_2023_INFO: makeAPI(Method.GET, '/activity/new-year-2023')(),
    POST_NEW_YEAR_2023_DRAW: makePlayerAPI(Method.POST, '/activity/new-year-2023')()
};
const DRAGON_BOAT_FESTIVAL_2023_API = {
    GET_DRAGON_BOAT_FESTIVAL_2023: makeAPI(Method.GET, '/activity/dragon-boat-festival-2023')(),
    POST_DRAGON_BOAT_FESTIVAL_2023: makePlayerAPI(Method.POST, '/activity/dragon-boat-festival-2023')()
};
const NEW_YEAR_2024_API = {
    GET_NEW_YEAR_2024_INFO: makeAPI(Method.GET, '/activity/new-year-2024')(),
    POST_NEW_YEAR_2024_DRAW: makePlayerAPI(Method.POST, '/activity/new-year-2024')(),
    GET_NEW_YEAR_2024_DEPOSIT_LIST: makePlayerAPI(Method.GET, '/activity/new-year-2024/deposits')(),
    GET_NEW_YEAR_2024_MARQUEE: makeAPI(Method.GET, '/activity/new-year-2024/marquee')()
};
const NEW_YEAR_2025_API = {
    GET_NEW_YEAR_2025_INFO: makeAPI(Method.GET, '/activity/snake-year-good-luck')(),
    POST_NEW_YEAR_2025_DRAW: makePlayerAPI(Method.POST, '/activity/snake-year-good-luck/draw')(),
    POST_NEW_YEAR_2025_RECEIVE_ENVELOPE: makePlayerAPI(Method.POST, '/activity/snake-year-good-luck/receive')()
};
const NEW_YEAR_API = {
    GET_NEW_YEAR_INFO: makeAPI(Method.GET, '/activity/new-year')(),
    POST_NEW_YEAR_DRAW: makePlayerAPI(Method.POST, '/activity/new-year/draw')(),
    POST_NEW_YEAR_RECEIVE_ENVELOPE: makePlayerAPI(Method.POST, '/activity/new-year/receive')()
};
const DEPOSIT_BONUS_API = {
    GET_DEPOSIT_BONUS: makeAPI(Method.GET, '/activity/deposit-bonus-2024')(),
    POST_DEPOSIT_BONUS: makePlayerAPI(Method.POST, '/activity/deposit-bonus-2024')()
};
const UEFA_BUILDING_UP_API = {
    GET_UEFA_BUILDING_UP: makeAPI(Method.GET, '/activity/uefa-building-up')(),
    POST_UEFA_BUILDING_UP_RECEIVE: makePlayerAPI(Method.POST, '/activity/uefa-building-up/receive')(),
    POST_UEFA_BUILDING_UP_APPLY: makePlayerAPI(Method.POST, '/activity/uefa-building-up/apply')()
};
const UEFA_STARS_API = {
    GET_UEFA_STARS: makeAPI(Method.GET, '/activity/uefa-stars')(),
    POST_UEFA_STARS: makePlayerAPI(Method.POST, '/activity/uefa-stars/draw')(),
    POST_UEFA_STARS_BUILD: makePlayerAPI(Method.POST, '/activity/uefa-stars/build-ga-team')()
};
const WEEKLY_BONUS_GOLD_API = {
    GET_WEEKLY_BONUS_GOLD: makeAPI(Method.GET, '/activity/weekly-bonus')()
};
const WEEKLY_BONUS_DRAW_API = {
    GET_WEEKLY_BONUS_DRAW: makeAPI(Method.GET, '/activity/weekly-bonus-draw')(),
    POST_WEEKLY_BONUS_DRAW: makePlayerAPI(Method.POST, '/activity/weekly-bonus-draw/draw')(),
    POST_WEEKLY_BONUS_DRAW_RECEIVE: makePlayerAPI(Method.POST, '/activity/weekly-bonus-draw/receive')()
};
const DAILY_BONUS_DRAW_API = {
    GET_DAILY_BONUS_DRAW: makeAPI(Method.GET, '/activity/daily-bonus-draw')(),
    POST_DAILY_BONUS_DRAW: makePlayerAPI(Method.POST, '/activity/daily-bonus-draw/draw')(),
    POST_DAILY_BONUS_DRAW_RECEIVE: makePlayerAPI(Method.POST, '/activity/daily-bonus-draw/receive')()
};
export const CAMPAIGN_API = {
    ...ACTIVITY_API,
    ...NEW_MEMBER_BONUS_API,
    ...RECOMMEND_FRIEND_API,
    ...INVITE_FRIEND_API,
    ...HIGH_CASH_BACK_API,
    ...NEW_YEAR_2023_API,
    ...DRAGON_BOAT_FESTIVAL_2023_API,
    ...NEW_YEAR_2024_API,
    ...NEW_YEAR_2025_API,
    ...NEW_YEAR_API,
    ...DEPOSIT_BONUS_API,
    ...UEFA_BUILDING_UP_API,
    ...UEFA_STARS_API,
    ...WEEKLY_BONUS_GOLD_API,
    ...WEEKLY_BONUS_DRAW_API,
    ...DAILY_BONUS_DRAW_API
};
//# sourceMappingURL=CampaignAPI.js.map